import { Routes } from '@angular/router';
import { LoginComponent } from './login/login';
import { DashboardComponent } from './dashboard/dashboard';
import { adminGuard, loggedOutGuard } from './core/auth.guards';

export const routes: Routes = [
  { path: '', component: LoginComponent, canActivate: [loggedOutGuard] },
  {
    path: 'forgot-password',
    canActivate: [loggedOutGuard],
    loadComponent: () =>
      import('./forgot-password/forgot-password').then((m) => m.ForgotPasswordComponent),
  },
  {
    path: 'reset-password',
    canActivate: [loggedOutGuard],
    loadComponent: () =>
      import('./reset-password/reset-password').then((m) => m.ResetPasswordComponent),
  },
  { path: 'dashboard', component: DashboardComponent, canActivate: [adminGuard] },
  {
    path: 'organizations',
    canActivate: [adminGuard],
    loadComponent: () =>
      import('./organizations/organizations').then((m) => m.OrganizationsComponent),
  },
  {
    path: 'accounts',
    canActivate: [adminGuard],
    loadComponent: () => import('./accounts/accounts').then((m) => m.AccountsComponent),
  },
  {
    path: 'users',
    canActivate: [adminGuard],
    loadComponent: () => import('./users/users').then((m) => m.UsersComponent),
  },
  {
    path: 'queues',
    canActivate: [adminGuard],
    loadComponent: () =>
      import('./queue-monitor/queue-monitor').then((m) => m.QueueMonitorComponent),
  },
  {
    path: 'kyc',
    canActivate: [adminGuard],
    loadComponent: () => import('./kyc/kyc-list').then((m) => m.KycListComponent),
  },
  {
    path: 'kyc/:id',
    canActivate: [adminGuard],
    loadComponent: () => import('./kyc/kyc-detail').then((m) => m.KycDetailComponent),
  },
  {
    path: 'audit-logs',
    canActivate: [adminGuard],
    loadComponent: () => import('./audit-logs/audit-logs').then((m) => m.AuditLogsComponent),
  },
  { path: '**', redirectTo: 'dashboard' },
];
